/**
 * Store: Geolocation
 * -----------------------------------------------------------------------------
 * Geolocation data persisted in Vuex state
 *
 * - Only JSDOC custom parameters, ignore module state or object.
 *
 */
export default {
  namespaced: true,

  state: () => ({
    postalCode: '',
    city: '',
    country: '',
    region: '',
  }),

  mutations: {

    /**
     * Set geolocation state.
     * @param {object} geolocation
     */
    SET_GEOLOCATION(state, geolocation) {
      state.postalCode = geolocation.postalCode
      state.city = geolocation.city
      state.country = geolocation.country
      state.region = geolocation.region
    },
  },

  actions: {

    /**
     * Commit geolocation state.
     * @param {object} geolocation - User geolocation information
     */
    setGeolocation({ commit }, geolocation) {
      commit('SET_GEOLOCATION', geolocation)
    },
  },
}
